module.exports = __webpack_public_path__ + "static/media/furnizori-istoric.51709144.svg";